/* eslint-disable import/prefer-default-export */

import { EventName } from 'modules/tracking/GA4/types/EventName';
import { AdvisorToolboxItemWithId } from './types';

export function trackingEventNameMapper(type: AdvisorToolboxItemWithId['type']): EventName | undefined {
    switch (type) {
        case 'Booking':
            return 'booking_selected';
        case 'Chat':
            return 'chat_selected';
        case 'Modiface':
            return 'modiface_activated';
        case 'Questionnaire':
            return 'questionnaire_selected';
        default:
            return undefined;
    }
}
